import React from 'react';
import { Box, Title, Link } from "../../../index.js";
import { RichText } from "../../../common/contentful";
import { CTA_VARIANTS } from "../../../molecules/components/Entry/constants";
export var InfoBox = function InfoBox(_ref) {
  var _ref$item = _ref.item,
    buttonLink = _ref$item.buttonLink,
    description = _ref$item.description,
    link = _ref$item.link,
    title = _ref$item.title,
    isProduct = _ref.isProduct;
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    ml: "24px",
    flex: "1"
  }, title && /*#__PURE__*/React.createElement(Title, {
    fontSize: isProduct ? {
      base: '16px',
      md: '20px'
    } : {
      base: '20px',
      md: '28px'
    },
    letterSpacing: {
      base: '0.18px'
    },
    marginBottom: {
      base: '12px'
    },
    lineHeight: {
      base: '24px',
      md: '28px'
    }
  }, title), description && /*#__PURE__*/React.createElement(RichText, {
    id: "banner",
    json: description,
    a: {
      color: 'red.500'
    },
    p: {
      whiteSpace: 'pre-wrap',
      margin: '14px 0'
    }
  }), (link === null || link === void 0 ? void 0 : link.title) && /*#__PURE__*/React.createElement(Link, {
    variant: "regular",
    url: link.url,
    openInNewTab: link.openInNewTab,
    sx: {
      wordBreak: 'break-word'
    }
  }, link.title), (buttonLink === null || buttonLink === void 0 ? void 0 : buttonLink.title) && /*#__PURE__*/React.createElement(Link, {
    variant: CTA_VARIANTS[buttonLink.variant],
    url: buttonLink.url,
    openInNewTab: buttonLink.openInNewTab,
    w: {
      base: '100%',
      md: 'auto'
    },
    sx: {
      wordBreak: 'break-word'
    },
    textAlign: "center"
  }, buttonLink.title));
};